import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CurrentUserModule } from '®shared/current-user';

import { ProductFruitsService } from './product-fruits.service';

@NgModule({
  imports: [CommonModule, CurrentUserModule],
  providers: [ProductFruitsService],
})
export class ProductFruitsModule {}
